import { PageHero } from "@/components/public/Layout";
import { Reveal, SectionLabel, ArchImage } from "@/components/public/shared";
import { useEnquiry } from "@/components/public/EnquiryProvider";
import { IMG } from "@/lib/images";

export default function Hospitality() {
  const { open } = useEnquiry();
  const services = [
    "F&B Management", "Kitchen Operations", "Menu Planning", "Catering Operations",
    "Hospitality Staffing", "Event Operations", "Food Production", "Service Management",
    "Daily Food Services", "Institutional Food Services",
  ];
  return (
    <div>
      <PageHero label="Hospitality & F&B Services" title="A company that operates hospitality — not just advises on it." subtitle="End-to-end F&B operations, kitchen management and service excellence, delivered by teams who run food services every day." image={IMG.service} />
      <section className="bg-ivory py-20 sm:py-28">
        <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
          <Reveal className="lg:col-span-6">
            <SectionLabel>What We Operate</SectionLabel>
            <h2 className="mt-5 font-display text-3xl font-light text-espresso sm:text-4xl">Broad F&B capabilities, under one roof</h2>
            <p className="mt-5 text-inkmuted">We bring culinary craft, trained teams and operational discipline together to run food and hospitality at any scale — with pure vegetarian & Jain-Friendly integrity throughout.</p>
            <div className="mt-8 grid grid-cols-2 gap-x-6 gap-y-3">
              {services.map((sv) => <div key={sv} className="text-sm text-espresso/90">— {sv}</div>)}
            </div>
            <button data-testid="hospitality-enquire" onClick={() => open("contact")} className="mt-10 inline-flex items-center gap-2 bg-espresso px-8 py-4 text-[12px] font-semibold uppercase tracking-editorial text-ivory transition-colors hover:bg-gold">
              Discuss a Partnership
            </button>
          </Reveal>
          <Reveal className="lg:col-span-6" delay={120}>
            <div className="grid grid-cols-2 gap-4">
              <ArchImage src={IMG.chefKitchen} alt="Kitchen operations" ratio="aspect-[3/4]" />
              <ArchImage src={IMG.chefPlating} alt="Plating craft" ratio="aspect-[3/4]" className="mt-10" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
